import React from 'react';
import styled from 'styled-components';

import { FormTitle, TextInput } from 'components/Core/Forms';

const Container = styled.div`
  /* padding: 20px 0 10px; */
`;

const HotelDeliveryForm = props => {
  const { book, onChange } = props;
  return (
    <Container>
      <FormTitle>Delivery Address</FormTitle>
      <TextInput
        label="Hotel Name"
        value={book.delivery.name}
        onChange={e => onChange('delivery.name', e.target.value)}
      />
      <TextInput
        label="Hotel Room number"
        value={book.delivery.room}
        onChange={e => onChange('delivery.room', e.target.value)}
      />
    </Container>
  );
};

export default HotelDeliveryForm;



// WEBPACK FOOTER //
// ./src/components/Form/HotelDeliveryForm.js